import React, { useState } from "react";

const Pagination = ({
  totalItems,
  itemsPerPage,
  onPageChange,
  currentPage,
  setCurrentPage,
  visiblePages = 5, // Set the number of visible page numbers
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [targetPage, setTargetPage] = useState(currentPage);

  const generatePageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const getVisiblePages = () => {
    const pageNumbers = generatePageNumbers();
    const start = Math.max(1, currentPage - Math.floor((visiblePages - 1) / 2));
    const end = Math.min(start + visiblePages - 1, totalPages);

    if (start > 1) {
      // Add the first page
      pageNumbers.splice(1, 0, "...");
    }

    if (end < totalPages) {
      // Add the last page
      pageNumbers.splice(pageNumbers.length - 1, 0, "...");
    }

    return pageNumbers.slice(start - 1, end);
  };

  const handlePageInputChange = (e) => {
    const inputPage = parseInt(e.target.value, 10);
    if (!isNaN(inputPage) && inputPage > 0 && inputPage <= totalPages) {
      setTargetPage(inputPage);
    }
  };

  const goToPage = () => {
    if (targetPage !== currentPage) {
      setCurrentPage(targetPage);
      onPageChange(targetPage);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      onPageChange(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      onPageChange(currentPage - 1);
    }
  };

  const handleFirst = () => {
    if (currentPage !== 1) {
      setCurrentPage(1);
      onPageChange(1);
    }
  };

  const handleLast = () => {
    if (currentPage !== totalPages) {
      setCurrentPage(totalPages);
      onPageChange(totalPages);
    }
  };

  return (
    <ul className="pagination pagination-sm m-0 float-right">
      <li
        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
        onClick={handleFirst}
      >
        <a className="page-link" href="#">
          First
        </a>
      </li>
      <li
        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
        onClick={handlePrevious}
      >
        <a className="page-link" href="#">
          Previous
        </a>
      </li>
      {getVisiblePages().map((pageNumber) => (
        <li
          key={pageNumber}
          className={`page-item ${
            currentPage === pageNumber || pageNumber === "..." ? "active" : ""
          }`}
          onClick={() =>
            pageNumber !== "..." ? onPageChange(pageNumber) : null
          }
        >
          <a className="page-link" href="#">
            {pageNumber}
          </a>
        </li>
      ))}
      <li
        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
        onClick={handleNext}
      >
        <a className="page-link" href="#">
          Next
        </a>
      </li>
      <li
        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
        onClick={handleLast}
      >
        <a className="page-link" href="#">
          Last
        </a>
      </li>
    </ul>
  );
};

export default Pagination;
